import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persistedstate'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexLocal],
  state: {
    lastRouter:'',
    version:"1.0.5"//版本号2020.6.15
  },
  mutations: {
    setParam(state, payload) {
      for (let i in payload) {
        state[i] = payload[i]
      }
    }
  }
})